import { TaskState, TaskAction } from 'stores/Recognition/types';

export enum SocketDataType {
  NEW_TRANSACTION = 'NEW_TRANSACTION',
  taskUpdate = 'taskUpdate',
  NEW_ONLINE_ORDERS = 'NEW_ONLINE_ORDERS',
}

export interface TransactionData {
  type: SocketDataType.NEW_TRANSACTION;
  payload: {
    source: 'EXTERNAL' | 'INTERNAL';
  };
}

export interface TaskUpdateData {
  type: SocketDataType.taskUpdate;
  payload: {
    id: string;
    type: string;
    state: TaskState;
    metrics: Record<string, string> & {
      progress?: string;
    };
    wfAllowedActions: TaskAction[];
    finishedAt: string;
  };
}

export interface NewOnlineOrdersData {
  type: SocketDataType.NEW_ONLINE_ORDERS;
  payload: {
    lastCreatedDate: string;
  };
}
